var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',{attrs:{"title":"Papelera","con-busqueda":""}},[_c('tabla-ofertas',{attrs:{"ofertas":_vm.resultado.ofertas}}),_c('paginacion',{attrs:{"page-count":_vm.resultado.numeroPaginas,"page":_vm.resultado.pagina}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }